import { Reducer } from "redux";

import { GateTesterAction, GateTesterActionTypes, GateTesterState } from "./types";

const initialState: GateTesterState = {
  flights: { isLoading: false },
  bookings: { isLoading: false },
};

const reducer: Reducer<GateTesterState, GateTesterAction> = (state = initialState, action) => {
  switch (action.type) {
    case GateTesterActionTypes.FLIGHTS_FETCH_REQUEST:
      return { ...state, flights: { isLoading: true } };
    case GateTesterActionTypes.FLIGHTS_FETCH_SUCCESS:
      return { ...state, flights: { result: action.payload, isLoading: false } };
    case GateTesterActionTypes.FLIGHTS_FETCH_ERROR:
      return { ...state, flights: { errors: action.payload, isLoading: false } };
    case GateTesterActionTypes.BOOKINGS_FETCH_REQUEST:
      return { ...state, bookings: { isLoading: true } };
    case GateTesterActionTypes.BOOKINGS_FETCH_SUCCESS:
      return { ...state, bookings: { result: action.payload, isLoading: false } };
    case GateTesterActionTypes.BOOKINGS_FETCH_ERROR:
      return { ...state, bookings: { errors: action.payload, isLoading: false } };
    default:
      return state;
  }
};

export default reducer;
